'use strict'

import errorService from '@/services/errorService'

var config, service, tabelle;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  tabelle = config.VUE_APP_MOL_S_TABLES
}

async function getRunMode() {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${tabelle}/mode`)
    return await response.json()
  } catch {
    return defaultRunMode()
  }
}

function defaultRunMode() {
  return {
    modulo: 'TABELLE',
    locale: '---',
    remote: '---',
    versione: '---',
    health: '---'
  }
}

/* async function searchTabelle(searchText) {
  const response = await fetch(`/${tabelle}/search?flt=${searchText}`)
  return await response.json()
}

async function getTabella(tabellaId, tipo) {
  try {
    const response = await fetch(`/${tabelle}/${tabellaId}${subConf ? '/' + subConf : ''}`)
    return await response.json()
  } catch (error) {
    errorService.onError(error, 'getTabella')
  }
}

async function creaTabella(tabella) {
  const response = await fetch('/${tabelle}/create', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(tabella)
  })
  return await response.json()
}

async function modificaTabella(tabella) {
  const response = await fetch(`/${tabelle}/${tabella._id}/update`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(tabella)
  })
  return await response.json()
} */

async function creaRigaTabella(riga) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${tabelle}/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(riga)
    })
    return await response.json()
  } catch (error) {
    errorService.onError(error, 'creaRigaTabella')
  }
}

async function getTabellaTipo(tipo) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${tabelle}/${tipo}`)
    return await response.json()
  } catch (error) {
    errorService.onError(error, 'getTabellaTipo')
  }
}

async function getTabella(tabellaId, subConf) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${tabelle}/detail/${tabellaId}${subConf ? '/' + subConf : ''}`)
    return await response.json()
  } catch (error) {
    errorService.onError(error, 'getTabella')
  }
}

async function getImpostazioniAnagraficaTabacchi() {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${tabelle}/custom/tabacchi/impostazioni`)
    return await response.json()
  } catch (error) {
    errorService.onError(error, 'getImpostazioniAnagraficaTabacchi')
  }
}

export default {
  getRunMode,
  creaRigaTabella,
  getTabella,
  getTabellaTipo,
  getImpostazioniAnagraficaTabacchi
/*   searchTabelle,
  getTabella,
  creaTabella,
  modificaTabella */
}
